import { EsiInclude } from '../lib/ESI'
import styles from './index.css'
import { Byline } from './Byline'
import { Share } from './Share'
import * as preact from 'preact'

const { h, Component } = preact

export const Footer = () => {
  return (
    <div>
      <div className={styles.published}>
        Publisert: 04.11.2018
      </div>
      <Byline />
      <Share />
      <div className={styles.footer}>
        <EsiInclude path={`https://www.nrk.no/serum/render?id=1.12592700`} />
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/v1/components/Footer/index.tsx